import styled from "styled-components";
import { palette } from "styled-theme";

const FeedWrapper = styled.div`
  .feedItemWrapper {
    padding: 10px 36px 0 20px;
  }
  .feedItem {
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
  .custom-collapse-section.feed .ant-collapse-content-box {
    padding-bottom: 0px !important;
  }
  .custom-collapse .ant-collapse-content {
    padding: 0px !important;
  }
  .custom-collapse .ant-collapse-content-box {
    padding: 0px !important;
  }
`;

export default FeedWrapper;
